<template >
  <div class="container" v-if="lesson">
    <div class="row">
      <div class="col-12">
        <div
          class="card mt-5 mb-5"
          v-if="!lesson.isGroup || (lesson.isGroup && lesson.isGroup == false)"
        >
          <div class="card-header">
            <div class="row">
              <div class="col col-expand">
                <h5 class="text-primary font-weight-bold">
                  Хичээл үзэж байгаа ангиуд
                </h5>
              </div>
              <div class="col col-auto" v-if="lesson.isGroup != true">
                <!-- v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')" -->
                <button
                  type="button"
                  class="btn btn-danger btn-sm mr-2"
                  @click="_addClassRoom"
                >
                  Анги нэмэх
                </button>
              </div>
            </div>
          </div>
          <div class="card-body project-tab" id="tabs">
            <table
              class="table table-sm table-bordered"
              v-if="lesson.groups && lesson.groups.length > 0"
            >
              <tr v-for="(group, index) in lesson.groups" :key="index">
                <td class="text-primary">
                  {{ group.departmentName
                  }}{{ group.programName.toUpperCase() }}
                </td>
                <td v-if="lesson.isGroup != true">
                  <div class="d-flex">
                    <button
                      title="Энэ товчыг дарсанаар тухайн ангийн сурагчид доор шүүгдэж харагдана."
                      type="button"
                      class="btn btn-mygray btn-sm mr-3"
                      @click="selectGroup(group)"
                    >
                      Сурагч харах
                    </button>
                    <!-- <button
                      type="button"
                      class="btn btn-danger btn-sm mr-auto"
                      @click="
                        $router.push({
                          name: 'ILessonLog',
                          params: {
                            schoolId: schoolId,
                            lessonId: lesson.id,
                            programId: group.program.id,
                            groupId: '1',
                          },
                        })
                      "
                    >
                      Ирц бүртгэл
                    </button> -->
                    <!-- <button type="button" class="btn btn-primary btn-sm mr-3" @click="$router.push({'name':'ILessonScores', params:{schoolId:schoolId, lessonId:lesson.id, programId: group.program.id }})">
                      Явцын дүн
                  </button> -->
                    <!-- <i
                      @click="_deleteClassRoom(group)"
                      class="fas fa-trash ml-2 text-secondary"
                      style="cursor: pointer"
                    ></i> -->
                    <button
                      type="button"
                      class="btn btn-danger btn-sm mr-3"
                      style="cursor: pointer"
                      @click="_deleteClassRoom(group)"
                    >
                      Aнги хасах
                    </button>
                  </div>
                </td>
              </tr>
            </table>
            <div v-else class="alert alert text-center">
              Одоогоор анги нэмээгүй байна.
            </div>
          </div>
        </div>

        <div
          class="card mt-5 mb-5"
          v-if="lesson.isGroup && lesson.isGroup == true"
        >
          <div class="card-header">
            <div class="row">
              <div class="col col-expand">
                <h5>Хичээл үзэж байгаа групп</h5>
              </div>
              <div class="col col-auto">
                <button
                  type="button"
                  class="btn btn-danger btn-sm mr-2"
                  @click="_addGroup"
                >
                  Групп+
                </button>

                <!-- <button type="button" class="btn btn-success btn-sm" @click="$router.push({'name':'ILessonScores', params:{schoolId:schoolId, lessonId:lesson.id}})">
              Явцын дүн
            </button> -->
              </div>
            </div>
          </div>
          <div class="card-body">
            <!-- <table
              class="table table-sm table-bordered"
              v-if="lesson.groups && lesson.groups.length > 0"
            >
              <tr v-for="department in lesson.groups" :key="department.id">
                <td>
                {{lesson.ref.path}}  {{ department.departmentName }} {{ department.programName }}
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-danger"
                    @click="_removeProgram(department)"
                  >
                    Xасаx
                  </button>
                </td>
              </tr>
            </table> -->
            <table
              class="table table-sm table-bordered"
              v-if="lesson.lessonGroups && lesson.lessonGroups.length > 0"
            >
              <tr v-for="group in lesson.lessonGroups" :key="group.id">
                <td>
                  {{ group.groupName }} 
                  <!-- -{{group.group.id}} -->
                </td>
                <td>
                  <button
                    title="Энэ товчыг дарсанаар тухайн бүлэгт шинээр сурагч нэмэх боломжтой"
                    type="button"
                    class="btn btn-success btn-sm mr-3"
                    @click="
                      $router.push({
                        name: 'GroupStudent',
                        params: {
                          schoolId: schoolId,
                          lessonId: group.group.id,
                        },
                      })
                    "
                  >
                    Группд cурагч+
                  </button>
                  <!-- <button v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')" type="button" class="btn btn-outline-danger btn-sm mr-3" @click="deleteGroupFromGroup(group);"> -->
                  <button
                    type="button"
                    class="btn btn-danger btn-sm mr-3"
                    @click="deleteGroupFromGroup(group)"
                  >
                    Групп хасах
                  </button>
                  <!-- <button
                    title="Энэ товчыг дарсанаар тухайн ангийн сурагчид доор шүүгдэж харагдана."
                    type="button"
                    class="btn btn-danger btn-sm mr-3"
                    @click="selectGroup(group, true)"
                  >
                    Сурагч харах
                  </button> -->
                  <!-- <button type="button" class="btn btn-info btn-sm mr-3" @click="$router.push({'name':'ILessonScores', params:{schoolId:schoolId, lessonId:lesson.id, groupId: group.group.id }})">
                    Явцын дүн
                  </button> -->
                  <!-- <button
                    type="button"
                    class="btn btn-info btn-sm mr-3"
                    @click="
                      $router.push({
                        name: 'ILessonLog',
                        params: {
                          schoolId: schoolId,
                          lessonId: lesson.id,
                          groupId: group.group.id,
                          programId: '1',
                        },
                      })
                    "
                  >
                    Ирц бүртгэл
                  </button> -->
                </td>
              </tr>
            </table>
            <div v-else class="alert alert warning text-center">
              Одоогоор групп нэмээгүй байна.
            </div>
          </div>
        </div>

        <div class="card" v-if="selectedGroup">
          <div class="card-header">
            <div>
              <h5>
                <span
                  v-if="
                    selectedGroup &&
                    selectedGroup.isGroup &&
                    selectedGroup.isGroup == true
                  "
                  >{{ selectedGroup.groupName }} группын</span
                >
                <span v-else
                  >{{ selectedGroup.departmentName }} -
                  {{ selectedGroup.programName }} ангийн</span
                >
                сурагчид
              </h5>
            </div>
          </div>
          <div class="card-body">
            <div
              class=""
              v-if="selectedGroup.students && selectedGroup.students.length > 0"
            >
              <table
                class="
                  table
                  table-sm
                  table-bordered
                  table-condensed
                  table-hover
                  table-striped
                "
              >
                <thead>
                  <tr>
                    <th>№</th>
                    <th class="text-primary">Овог нэр</th>
                    <th class="text-primary">Анги бүлэг</th>
                    <th class="text-primary">Код</th>
                    <th class="text-primary">Хүйс</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(student, index) in selectedGroup.students"
                    :key="index"
                  >
                    <td class="text-center" style="width: 2%">
                      {{ index + 1 }}
                    </td>
                    <td>
                      <span
                        v-if="student.lastname && student.lastname.length > 0"
                      >
                        <span
                          v-if="
                            student.lncount &&
                            student.lncount > 1 &&
                            student.lastname.length >= student.lncount
                          "
                          >{{
                            student.lastname.substring(0, student.lncount)
                          }}</span
                        >
                        <span v-else>{{ student.lastname[0] }}</span
                        >.
                      </span>
                      {{ student.name }}
                    </td>
                    <td>
                      <div>
                        <span v-if="student.departmentName != null">{{
                          student.departmentName
                        }}</span>
                        <span v-else>-</span>

                        <span v-if="student.programName != null"
                          >/ {{ student.programName }}</span
                        >
                        <span v-else>-</span>
                      </div>
                    </td>
                    <td>{{ student.code }}</td>
                    <td>
                      <div
                        v-if="
                          student.gender != null && student.gender != undefined
                        "
                      >
                        <span v-if="student.gender == 0">эрэгтэй</span>
                        <span v-if="student.gender == 1">эмэгтэй</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <span class="text-danger">{{ selectedGroup.groupName }} группт сурагч байхгүй байна.</span>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Анги нэмэх</h5>

                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form class="user">
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label for="exampleFormControlSelect1">Сургууль:</label>
                        <select
                          class="form-control"
                          v-model="school"
                          @change="schoolChanged"
                        >
                          <option
                            v-for="school in schools"
                            v-bind:key="school.id"
                            v-bind:value="school"
                          >
                            {{ school.data().name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col" v-if="school != null">
                      <div class="form-group">
                        <label for="exampleFormControlSelect1">Анги:</label>
                        <select class="form-control" v-model="department">
                          <option
                            v-for="dep in school.departments"
                            v-bind:key="dep.id"
                            v-bind:value="dep"
                          >
                            {{ dep.data().name }} - {{ dep.data().startYear }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-if="department != null">
                    <!-- <label for="exampleFormControlSelect1">Бүлэг:</label> -->

                    <div class="d-flex flex-row my-3 justify-content-center">
                      <div
                        @click="toggleDepartmentFilter(pro, selectedPrograms)"
                        :key="pindex"
                        style="cursor: pointer; font-size: 26px"
                        class="badge px-3 py-2 mr-2"
                        v-for="(pro, pindex) in department.programs"
                        v-bind:class="[
                          isInDepartmentFilter(pro, selectedPrograms) == true
                            ? 'badge-success text-black'
                            : 'text-primary bg-light ',
                        ]"
                      >
                        {{ pro.data().name.toUpperCase() }}
                      </div>
                    </div>
                    <!-- <select class="form-control" v-model="program" >
                    <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{pro.data().name}}</option>
                  </select> -->
                  </div>

                  <hr />
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Цуцлаx
                </button>
                <button
                  @click="_addProgram"
                  type="button"
                  class="btn btn-primary btn-user btn-block"
                  data-dismiss="modal"
                >
                  Xадгалаx
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="groupModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="groupModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="groupModalLabel">Групп нэмэх</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form class="user">
                  <div class="row">
                    <div class="alert alert-warning">
                      Xэдэн xэдэн группуудыг сонгож болно. Xэрэв сонголтоо
                      арилгаx бол даxин сонголт дээрээ дарна.
                    </div>
                  </div>
                  <div class="form-group" v-if="school != null">
                    <div style="width: 100%; overflow: auto; max-height: 600px">
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                      >
                        <tr v-for="(grp, gindex) in lessonGroups" :key="gindex">
                          <template
                            v-if="
                              grp.data().startYear == 2021 &&
                              grp.data().startMonth >= 9
                            "
                          >
                            <td>{{ gindex + 1 }}</td>
                            <td>
                              {{ grp.data().name }}, {{ grp.data().startYear }},
                              {{ grp.data().startMonth }}
                            </td>
                            <td class="text-center">
                              <span
                                @click="
                                  toggleDepartmentFilter(grp, selectedGroups)
                                "
                                style="cursor: pointer; font-size: 14px"
                                class="badge px-3 py-2 mr-2 my-2"
                                v-bind:class="[
                                  isInDepartmentFilter(grp, selectedGroups) ==
                                  true
                                    ? 'badge-success text-black'
                                    : 'text-primary bg-light ',
                                ]"
                                >+</span
                              >
                            </td>
                          </template>
                        </tr>
                      </table>
                    </div>
                    <!-- <select class="form-control" v-model="program" >
                    <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{pro.data().name}}</option>
                  </select> -->
                  </div>

                  <hr />
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  @click="_saveGroup"
                  type="button"
                  class="btn btn-primary btn-user btn-block"
                  data-dismiss="modal"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
export default {
  name: "ILessonGroup",

  data() {
    return {
      lesson: null,
      topic: {
        name: null,
        description: null,
        price: 0,
        tags: [],
        shortname: null,
      },
      content: {
        name: null,
        description: null,
        videoUrl: null,
        published: false,
        startDay: null,
        endDay: null,
        code: null,
        duration: null,
        shortname: null,
      },
      topics: [],
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],
      tmpAdditionalFile: {
        name: "",
        uploading: false,
        uploadPercent: null,
      },
      lessonBucket: "lessonFiles/",
      topicBucket: "lessonTopicFiles/",
      display: 0,
      tagText: null,
      schools: [],
      school: null,
      department: null,
      program: null,
      selectedPrograms: [],
      selectedGroups: [],
      lessonGroups: [],
      selectedGroup: null,
    };
  },
  methods: {
    async _setupp() {
      var school = await fb.db.collection("schools").doc(this.schoolId).get();
      this.school = school.data();
      this.school.ref = school.ref;
      this.school.id = school.id;
      fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .onSnapshot((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          this.lesson = lesson;
          this.lesson.ref = doc.ref;

          if (
            lesson.isGroup != null &&
            lesson.isGroup != undefined &&
            lesson.isGroup == true
          ) {
            if (lesson.lessonGroups && lesson.lessonGroups.length > 0) {
              this.selectGroup(lesson.lessonGroups[0], true);
            }
          } else {
            if (lesson.groups && lesson.groups.length > 0) {
              this.selectGroup(lesson.groups[0], false);
            }
          }
        });
    },

    saveTopic() {
      if (
        this.lesson != null &&
        this.topic != null &&
        this.topic.name != "" &&
        this.topic.description != ""
      ) {
        if (this.topic.price != null && this.topic.price == "")
          this.topic.price = 0;
        if (
          this.topic.id != null &&
          this.topic.id != "" &&
          this.topic.id != "new"
        ) {
          this.topic.modifiedAt = new Date();
          fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("topics")
            .doc(this.topic.id)
            .update(this.topic);
        } else {
          var now = new Date();
          this.topic.createdAt = now;

          fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("topics")
            .doc()
            .set(this.topic);
          fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .update({
              numberOfTopics: fb.firestore.FieldValue.increment(1),
            });
        }
        this.topic = {
          name: null,
          description: null,
          price: 0,
          tags: [],
          shortname: null,
        };
      }
    },

    addStudents() {
      if (this.studentsText != null && this.studentsText != "") {
        var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
        arrayOfLines.forEach((value) => {
          // console.log(value);
          var lineArray = value.split(/\s+/);

          if (
            lineArray != null &&
            lineArray.length == 2 &&
            lineArray[0] != null &&
            lineArray[0] != "" &&
            lineArray[1] != null &&
            lineArray[1] != ""
          ) {
            var lessonRef = fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId);
            var studentRef = fb.db
              .collection("schools/" + this.schoolId + "/students")
              .doc()
              .get()
              .then((studentData) => {
                var studentDetail;
                var saveStudent = true;
                if (studentData != null && studentData.exists) {
                  // studentData.ref.update({
                  // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef)
                  // });
                  studentDetail = studentData.data();
                  this.addStudentToLesson(
                    lessonRef,
                    studentData,
                    studentDetail
                  );
                } else {
                  fb.db
                    .collection("schools/" + this.schoolId + "/students")
                    .where("register", "==", lineArray[1].toLowerCase())
                    .get()
                    .then((value) => {
                      if (value.empty) {
                        studentDetail = {
                          code: lineArray[0].toLowerCase(),
                          register: lineArray[1].toLowerCase(),
                          // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef),
                          created: fb.usersCollection.doc(
                            this.$store.getters.currentUser.uid
                          ),
                          createdAt: new Date(),
                        };
                        studentData.ref.set(studentDetail);
                        this.addStudentToLesson(
                          lessonRef,
                          studentData,
                          studentDetail
                        );
                      }
                    });
                }
              });
          }
        });
        this.studentsText = "";
      }
    },
    addStudentToLesson(lessonRef, studentData, studentDetail) {
      studentData.ref
        .collection("lessonList")
        .doc(lessonRef.id)
        .get()
        .then((stLesson) => {
          if (stLesson != null && stLesson.exists) {
          } else {
            studentData.ref
              .collection("lessonList")
              .doc(lessonRef.id)
              .set({
                lessonRef: lessonRef,
                addedDate: new Date(),
                addedUser: fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                ),
                enabled: true,
                semester: this.lesson.semester,
              });
          }
        });

      lessonRef
        .collection("studentList")
        .doc(studentData.id)
        .get()
        .then((lessonSt) => {
          if (lessonSt != null && lessonSt.exists) {
          } else {
            lessonRef.update({
              numberOfStudents: fb.firestore.FieldValue.increment(1),
            });
            lessonRef
              .collection("studentList")
              .doc(studentData.id)
              .set({
                addedDate: new Date(),
                addedUser: fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                ),
                studentRef: studentData.ref,
                enabled: true,
                semester: this.lesson.semester,
              });
          }
        });
    },
    _addClassRoom() {
      // this.school=null;
      this.department = null;
      this.program = null;
      this.selectedPrograms = [];
      $("#exampleModal").modal("toggle");
    },
    _addGroup() {
      this.selectedGroups = [];
      $("#groupModal").modal("toggle");
    },

    _deleteLessonFile(file, index) {
      var result = confirm("Та " + file.title + " файлыг устгах уу?");
      if (result) {
        var fileName = file.uploadedAt.toDate().getTime() + "_" + file.fileName;
        var fileRef = fb.storageRef.child(this.lessonBucket + fileName);
        // Delete the file
        fileRef
          .delete()
          .then(() => {
            this.lesson.files.splice(index, 1);
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .update({
                files: this.lesson.files,
              });
          })
          .catch(function (error) {});
      }
    },
    setEnabledForStudent(stddata, value) {
      this.setProperty("enabled", stddata.ref, value);
      this.setProperty(
        "enabled",
        fb.db.doc(
          "schools/" +
            this.schoolId +
            "/students/" +
            stddata.id +
            "/lessonList/" +
            this.lessonId
        ),
        value
      );
    },
    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },
    removeStudent(stddata) {
      var batch = fb.db.batch();
      batch.delete(
        fb.db.doc(
          "schools/" +
            this.schoolId +
            "/students/" +
            stddata.id +
            "/lessonList/" +
            this.lessonId
        )
      );
      batch.delete(stddata.ref);
      batch.update(
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId),
        {
          numberOfStudents: fb.firestore.FieldValue.increment(-1),
        }
      );
      batch.commit();
    },
    setPublished(value, lesson) {},
    setPropContent(value, topic, item, propertyName) {
      if (
        this.lesson != null &&
        topic != null &&
        item != null &&
        propertyName != null
      )
        this.setProperty(
          propertyName,
          fb.db.doc(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lesson.id +
              "/topics/" +
              topic.id +
              "/details/" +
              item.id
          ),
          value
        );
    },
    _getSchools() {
      // fb.db.collection("schools").doc(this.schoolId)
      // .get()
      // .then(schoolData=> {

      //       this._getDepartments(schoolData.id, schoolData);
      //       this.schools.push(schoolData);

      // })
      // .catch(function(error) {
      //     console.log("Error getting documents: ", error);
      // });
      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolData) => {
          this._getDepartments(schoolData.id, schoolData);

          // this.school=schoolData;
          this.schools.push(schoolData);
        });
    },
    _getDepartments(schoolId, schoolData) {
      schoolData.ref
        .collection("departments")
        .orderBy("index")
        .where("startYear", "==", this.school.currentYear) //TODOX
        .get()
        .then((querySnapshot) => {
          let deps = [];
          querySnapshot.forEach((depdata) => {
            this._getPros(depdata);
            deps.push(depdata);

            // fb.db.collection("lessons").where("department", "==", depdata.ref).get().then(values=>{
            //   depdata.ref.update({"numberOfLessons": values.size});
            // });

            // fb.db.collection("lessons").where("department", "==", depdata.ref).where("published","==", true).get().then(values=>{
            //   depdata.ref.update({"publishedLesson": values.size});
            // });
          });
          schoolData.departments = deps;

          if (schoolData) {
            this._getGroups(schoolData.id, schoolData);
          }
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getPros(depdata) {
      depdata.ref
        .collection("programs")
        .orderBy("name")
        .get()
        .then((querySnapshot) => {
          let pros = [];
          querySnapshot.forEach((prodata) => {
            pros.push(prodata);
            // fb.db.collection("lessons").where("program", "==", prodata.ref).get().then(values=>{
            //   prodata.ref.update({"numberOfLessons": values.size});
            // });

            // fb.db.collection("lessons").where("program", "==", depdata.ref).where("published","==", true).get().then(values=>{
            //   prodata.ref.update({"publishedLesson": values.size});
            // });
          });
          depdata.programs = pros;
        });
    },
    _getGroups(schoolId, schoolData) {
      if (this.userProfile) {
        if (
          this.userProfile &&
          this.userProfile["role"] != null &&
          (this.userProfile["role"] == "admin" ||
            this.userProfile["role"] == "sts")
        ) {
          schoolData.ref
            .collection("lessonGroups")
            .orderBy("createdAt")
            .get()
            .then((querySnapshot) => {
              let deps = [];
              querySnapshot.forEach((depdata) => {
                deps.push(depdata);
              });
              this.lessonGroups = deps;
            });
        } else {
          schoolData.ref
            .collection("lessonGroups")
            .where("teacher", "==", this.userProfile["customer"])
            .orderBy("createdAt", "desc")
            .get()
            .then((querySnapshot) => {
              let deps = [];
              querySnapshot.forEach((depdata) => {
                console.lo;
                deps.push(depdata);
              });
              this.lessonGroups = deps;
            });
        }
      }
    },
    schoolChanged() {
      this.department = null;
      this.program = null;
      this.selectedPrograms = [];
      this, (selectedGroups = []);
      if (this.school) {
        this._getGroups(this.school.id, this.school);
      }
    },
    _addProgram() {
      if (
        this.school &&
        this.department &&
        this.selectedPrograms &&
        this.selectedPrograms.length > 0
      ) {
        for (const program of this.selectedPrograms) {
          var exists = false;
          if (
            this.lesson != null &&
            this.lesson != undefined &&
            this.lesson.groups != null &&
            this.lesson.groups != undefined &&
            this.lesson.groups.length > 0
          ) {
            for (const tmp of this.lesson.groups) {
              if (
                tmp != null &&
                tmp != undefined &&
                tmp.program != null &&
                tmp.program != undefined &&
                tmp.program.id == program.id
              ) {
                exists = true;
              }
            }
          }
          if (exists == false) {
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lesson.id)
              .update({
                groups: fb.firestore.FieldValue.arrayUnion({
                  school: this.school.ref,
                  department: this.department.ref,
                  program: program.ref,
                  schoolName: this.school.data().name,
                  departmentName: this.department.data().name,
                  programName: program.data().name,
                }),
                programs: fb.firestore.FieldValue.arrayUnion(program.ref),
                programIds: fb.firestore.FieldValue.arrayUnion(program.id),
                departments: fb.firestore.FieldValue.arrayUnion(
                  this.department.ref
                ),
                classNos: fb.firestore.FieldValue.arrayUnion(
                  this.department.data().index
                    ? this.department.data().index
                    : 0
                ),
              });
            // this.findStudents(this.school.ref, this.department.ref, program.ref);
          } else {
            alert(program.data().name + " аль хэдийн нэмэгдсэн байна.");
          }
        }
      } else {
        alert("Групп сонголт xийгдээгүй байна!");
      }
    },
    _saveGroup() {
      if (
        this.school &&
        this.selectedGroups &&
        this.selectedGroups.length > 0
      ) {
        for (const group of this.selectedGroups) {
          var exists = false;
          if (
            this.lesson != null &&
            this.lesson != undefined &&
            this.lesson.lessonGroups &&
            this.lesson.lessonGroups.length > 0
          ) {
            for (const tmp of this.lesson.lessonGroups) {
              if (
                tmp != null &&
                tmp != undefined &&
                tmp.group &&
                tmp.group.id == group.id
              ) {
                exists = true;
                break;
              }
            }
          }
          if (exists == false) {
            console.log(this.school);
            console.log(group.data().name, this.lesson.id);
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lesson.id)
              .update({
                lessonGroups: fb.firestore.FieldValue.arrayUnion({
                  school: this.school.ref,
                  group: group.ref,
                  schoolName: this.school.name,
                  groupName: group.data().name,
                }),
                lessonGroupRefs: fb.firestore.FieldValue.arrayUnion(group.ref),
                lessonGroupIds: fb.firestore.FieldValue.arrayUnion(group.id),
              });
            group.ref.update({ lesson: this.lesson.ref });
            this.addClassToGroup(group);
          } else {
            alert(group.data().name + " аль хэдийн нэмэгдсэн байна.");
          }
        }
      } else {
        alert("Та мэдээллээ бүрэн оруулна уу.");
      }
    },
    findStudents(sc, dep, pro) {
      fb.db
        .collection("schools/" + this.schoolId + "/students")
        .where("school", "==", sc)
        .where("department", "==", dep)
        .where("program", "==", pro)
        .get()
        .then((docs) => {
          for (const studentData of docs.docs) {
            if (studentData != null && studentData.exists) {
              var studentDetail = studentData.data();
              this.addStudentToLesson(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                studentData,
                studentDetail
              );
            }
          }
        });
    },
    findStudentsByGroup(group) {
      fb.db
        .collection("schools/" + this.schoolId + "/students")
        .where("lessonGroups", "array-contains", group)
        .get()
        .then((docs) => {
          for (const studentData of docs.docs) {
            if (studentData != null && studentData.exists) {
              var studentDetail = studentData.data();
              this.addStudentToLesson(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                studentData,
                studentDetail
              );
            }
          }
        });
    },
    async removeStudents(sc, dep, pro) {
      var docs = await fb.db
        .collection("schools/" + this.schoolId + "/students")
        .where("school", "==", sc)
        .where("department", "==", dep)
        .where("program", "==", pro)
        .get();
      for (const studentData of docs.docs) {
        if (studentData != null && studentData.exists) {
          var stdRef = fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("studentList")
            .doc(studentData.id);
          var stddata = await stdRef.get();
          if (stddata.exists) {
            this.removeStudent(stddata);
          }
        }
      }
    },
    async removeStudentsByGroup(group) {
      var docs = await fb.db
        .collection("schools/" + this.schoolId + "/students")
        .where("lessonGroups", "array-contains", group)
        .get();
      for (const studentData of docs.docs) {
        if (studentData != null && studentData.exists) {
          var stdRef = fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("studentList")
            .doc(studentData.id);
          var stddata = await stdRef.get();
          if (stddata.exists) {
            this.removeStudent(stddata);
          }
        }
      }
    },
    async _deleteClassRoom(group) {
      var r = confirm(
        "Та " +
          group.departmentName +
          "/" +
          group.programName +
          " ангийг хасахдаа итгэлтэй байна уу? Таны оруулсан дүнгүүд XАМТ устгагдана!"
      );
      if (r == true) {
        await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lesson.id)
          .update({
            groups: fb.firestore.FieldValue.arrayRemove(group),
            programs: fb.firestore.FieldValue.arrayRemove(group.program),
            programIds: fb.firestore.FieldValue.arrayRemove(group.program.id),
            departments: fb.firestore.FieldValue.arrayRemove(group.department),
            classNos: fb.firestore.FieldValue.arrayRemove(
              group.departmentName ? parseInt(group.departmentName) : 0
            ),
          });
        // this.removeStudents(group.school, group.department, group.program);
        this.check();
      }
    },
    async _removeProgram(department) {
      var r = confirm(
        "Та " +
          department.departmentName +
          " ангийг хасахдаа итгэлтэй байна уу? Таны оруулсан дүнгүүд XАМТ устгагдана!"
      );
      if (r == true) {
        await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lesson.id)
          .update({
            groups: fb.firestore.FieldValue.arrayRemove(department),
          });
        // this.removeStudents(group.school, group.department, group.program);
        this.check();
      }
    },
    async deleteGroupFromGroup(group) {
      console.log(group);
      var r = confirm(
        "Xичээлээс " +
          group.groupName +
          " группыг хасах уу? Энэ xичээлээс туxайн группыг xасна. Группт байгаа сурагчид xасагдаxгүй xадгалагдана."
      );
      if (r == true) {
        await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lesson.id)
          .update({
            lessonGroups: fb.firestore.FieldValue.arrayRemove(group),
            lessonGroupRefs: fb.firestore.FieldValue.arrayRemove(group.group),
            lessonGroupIds: fb.firestore.FieldValue.arrayRemove(group.group.id),
          });

        var batch = fb.db.batch();
        var group = await group.group.get();
        if (group && group.exists) {
          if (group && group.data() && group.data().groups) {
            for (const data of group.data().groups) {
              batch.update(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                {
                  groups: fb.firestore.FieldValue.arrayRemove(data),
                }
              );
            }
          }
          if (group && group.data() && group.data().programs) {
            for (const data of group.data().programs) {
              batch.update(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                {
                  programs: fb.firestore.FieldValue.arrayRemove(data),
                }
              );
            }
          }
          if (group && group.data() && group.data().programIds) {
            for (const data of group.data().programIds) {
              batch.update(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                {
                  programIds: fb.firestore.FieldValue.arrayRemove(data),
                }
              );
            }
          }
          if (group && group.data() && group.data().departments) {
            for (const data of group.data().departments) {
              batch.update(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                {
                  departments: fb.firestore.FieldValue.arrayRemove(data),
                }
              );
            }
          }
          if (group && group.data() && group.data().classNos) {
            for (const data of group.data().classNos) {
              batch.update(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                {
                  classNos: fb.firestore.FieldValue.arrayRemove(data),
                }
              );
            }
          }
          batch.commit().then(() => {
            this.selectedGroup = null;
          });
        }
        // this.removeStudentsByGroup(group.group);
        // this.check();
        this.checkGroup();
      }
    },
    check() {
      if (this.lesson && this.lesson.groups && this.lesson.groups) {
        for (const groupData of this.lesson.groups) {
          if (groupData) {
            var updateObject = {};
            if (groupData.program && groupData.program.id) {
              updateObject.programIds = fb.firestore.FieldValue.arrayUnion(
                groupData.program.id
              );
              updateObject.programs = fb.firestore.FieldValue.arrayUnion(
                groupData.program
              );
            }
            if (groupData.departmentName) {
              var indexNo = parseInt(groupData.departmentName);
              updateObject.classNos =
                fb.firestore.FieldValue.arrayUnion(indexNo);
            }
            if (groupData.department) {
              updateObject.departments = fb.firestore.FieldValue.arrayUnion(
                groupData.department
              );
            }
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .update(updateObject);
          }
        }
      }
    },
    checkGroup() {
      if (this.lesson && this.lesson.lessonGroups && this.lesson.lessonGroups) {
        for (const groupData of this.lesson.lessonGroups) {
          if (groupData) {
            var updateObject = {};

            if (groupData.group && groupData.group.id) {
              updateObject.lessonGroupIds = fb.firestore.FieldValue.arrayUnion(
                groupData.group.id
              );
              updateObject.lessonGroupRefs = fb.firestore.FieldValue.arrayUnion(
                groupData.group
              );

              groupData.group.get().then((groupDoc) => {
                this.addClassToGroup(groupDoc);
              });
            }

            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .update(updateObject);
          }
        }
      }
    },
    addClassToGroup(group) {
      var batch = fb.db.batch();

      if (group && group.data() && group.data().groups) {
        for (const data of group.data().groups) {
          batch.update(
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lesson.id),
            {
              groups: fb.firestore.FieldValue.arrayUnion(data),
            }
          );
        }
      }
      if (group && group.data() && group.data().programs) {
        for (const data of group.data().programs) {
          batch.update(
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lesson.id),
            {
              programs: fb.firestore.FieldValue.arrayUnion(data),
            }
          );
        }
      }
      if (group && group.data() && group.data().programIds) {
        for (const data of group.data().programIds) {
          batch.update(
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lesson.id),
            {
              programIds: fb.firestore.FieldValue.arrayUnion(data),
            }
          );
        }
      }
      if (group && group.data() && group.data().departments) {
        for (const data of group.data().departments) {
          batch.update(
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lesson.id),
            {
              departments: fb.firestore.FieldValue.arrayUnion(data),
            }
          );
        }
      }
      if (group && group.data() && group.data().classNos) {
        for (const data of group.data().classNos) {
          batch.update(
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lesson.id),
            {
              classNos: fb.firestore.FieldValue.arrayUnion(data),
            }
          );
        }
      }
      batch.commit();
    },
    toggleDepartmentFilter(department, list) {
      if (this.isInDepartmentFilter(department, list) == true) {
        this.removeFromDepartmentFilter(department, list);
      } else {
        list.push(department);
      }
    },
    isInDepartmentFilter(department, list) {
      var exists = false;
      for (const current of list) {
        if (current && current.id && current.id == department.id) {
          exists = true;
          break;
        }
      }
      return exists;
    },
    removeFromDepartmentFilter(department, list) {
      var exists = false;
      var index = 0;
      var i = 0;
      for (const current of list) {
        if (current && current.id && current.id == department.id) {
          exists = true;
          index = i;
          break;
        }
        i++;
      }
      if (exists && exists == true) {
        list.splice(index, 1);
      }
    },
    async selectGroup(group, isGroup) {
      if (group) {
        var tmp = Object.assign({}, group);
        if (tmp) {
          if (!tmp.students) {
            tmp.students = [];
          }
          tmp.isGroup = isGroup;
          if (isGroup && isGroup == true) {
            var stdocs = await fb.db
              .collection("schools/" + this.schoolId + "/students")
              .where("lessonGroups", "array-contains", group.group)
              .get();
            if (!stdocs.empty) {
              for (const studentDoc of stdocs.docs) {
                let student = studentDoc.data();
                student.id = studentDoc.id;
                student.departmentName = null;
                student.programName = null;

                // "department-" + this.department.startYear TODOZ
                if (student["department-" + this.school.currentYear]) {
                  student["department-" + this.school.currentYear]
                    .get()
                    .then((ddoc) => {
                      if (ddoc.exists) {
                        student.departmentName = ddoc.data().name;
                      }
                    });
                }
                if (student["program-" + this.school.currentYear]) {
                  student["program-" + this.school.currentYear]
                    .get()
                    .then((ddoc) => {
                      if (ddoc.exists) {
                        student.programName = ddoc.data().name;
                      }
                    });
                }
                tmp.students.push(student);
              }
            }
          } else {
            var stdocs = await fb.db
              .collection("schools/" + this.schoolId + "/students")
              .where("program-" + this.school.currentYear, "==", group.program)
              .orderBy("name", "asc")
              .get();
            if (!stdocs.empty) {
              for (const studentDoc of stdocs.docs) {
                let student = studentDoc.data();
                student.id = studentDoc.id;
                student.departmentName = null;
                student.programName = null;
                if (student["department-" + this.school.currentYear]) {
                  student["department-" + this.school.currentYear]
                    .get()
                    .then((ddoc) => {
                      if (ddoc.exists) {
                        student.departmentName = ddoc.data().name;
                      }
                    });
                }
                if (student["program-" + this.school.currentYear]) {
                  student["program-" + this.school.currentYear]
                    .get()
                    .then((ddoc) => {
                      if (ddoc.exists) {
                        student.programName = ddoc.data().name;
                      }
                    });
                }
                tmp.students.push(student);
              }
            }
          }
          this.selectedGroup = tmp;
        }
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
  },
  created() {
    var _this = this;
    if (this.lessonId != null && this.lessonId != "") {
      this._setupp();
      this._getSchools();
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
<style scoped>
.project-tab #tabs {
  background: #007b5e;
  color: #eee;
}
.project-tab #tabs h6.section-title {
  color: #eee;
}
.project-tab #tabs .nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #0062cc;
  background-color: transparent;
  border-color: transparent transparent #f3f3f3;
  border-bottom: 3px solid !important;
  font-size: 16px;
  font-weight: bold;
}
.project-tab .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  color: #0062cc;
  font-size: 16px;
  font-weight: 600;
}
.project-tab .nav-link:hover {
  border: none;
}
</style>

